"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _component = require("../component");

var _types = require("../Datum/types");

var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(_default, _PureComponent);

  function _default(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleUpdate = _this.forceUpdate.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = _default.prototype;

  _proto.componentDidMount = function componentDidMount() {
    _PureComponent.prototype.componentDidMount.call(this);

    this.props.datum.subscribe(_types.CHANGE_TOPIC, this.handleUpdate);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    _PureComponent.prototype.componentWillUnmount.call(this);

    this.props.datum.unsubscribe(_types.CHANGE_TOPIC, this.handleUpdate);
  };

  _proto.getChecked = function getChecked() {
    var _this$props = this.props,
        data = _this$props.data,
        datum = _this$props.datum;
    if (datum.length === 0 || !data) return false;
    var checked;

    for (var _iterator = data, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var d = _ref;
      if (datum.disabled(d)) continue;
      var p = datum.check(d);

      if (checked === undefined) {
        checked = p;
      } else if (checked !== p) {
        return 'indeterminate';
      }
    }

    return checked;
  };

  _proto.handleChange = function handleChange(_, checked, index) {
    var _this$props2 = this.props,
        data = _this$props2.data,
        datum = _this$props2.datum;

    if (checked) {
      datum.add(data, index);
    } else {
      datum.remove(data, index);
    }
  };

  _proto.render = function render() {
    if (this.props.datum.limit === 1) return null;
    return _react.default.createElement(_Checkbox.default, _extends({}, this.props, {
      checked: this.getChecked(),
      onChange: this.handleChange
    }));
  };

  return _default;
}(_component.PureComponent);

exports.default = _default;

_defineProperty(_default, "propTypes", {
  data: _propTypes.default.array,
  datum: _propTypes.default.object.isRequired
});